import React, { useEffect, useState } from "react";
import axios from "../../axiosinstens";

import "./Categorie.css";
import { useNavigate } from "react-router-dom";
import Layouts from "../../Components/Layouts/Layouts";
import { environment } from "../../environment";
import { Helmet } from "react-helmet-async";
function Categorie() {
  const [catagory, setCatagorys] = useState([]);
  const navigate = useNavigate();

  const getCatagorys = async () => {
    try {
      const response = await axios.get("getAllCategorie");
      setCatagorys(response.data.categories);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getCatagorys();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Martial Arts Events & Tournaments USA | Spectacular Seminars
        </title>

        <meta
          name="description"
          content="Explore upcoming martial arts seminars, tournaments, workshops, and training events across the USA. Join professional instructors, schools, and martial arts enthusiasts at Spectacular Seminars."
        />

        <meta
          name="keywords"
          content="martial arts events USA, martial arts tournaments, karate events, taekwondo seminars, MMA workshops, jiu jitsu tournaments, martial arts training events, self defense workshops, martial arts classes USA, martial arts championships, combat sports events, martial arts networking, instructor seminars, spectacular seminars events"
        />
      </Helmet>

      <Layouts>
        <div className="evn">
          <h2>
            <span>Our</span> Events
          </h2>
          <hr />
        </div>

        <div className="evnsam">
          <section className="evnsam_container">
            <div className="row">
              <div className="col-md-4">
                <div
                  className="evnsam-catagory"
                  onClick={() =>
                    navigate(`/eventslistall`, {
                      state: { categorie_id: "all" },
                    })
                  }
                  style={{ cursor: "pointer" }}
                >
                  {/* <figure>
                    <img
                      src={`${environment.imageBaseURL}categorie/${catagory_data.image}`}
                      alt=""
                    />
                  </figure> */}
                  <div className="evnsam-name" style={{ opacity: 1 }}>
                    <h4>View All</h4>
                  </div>
                </div>
              </div>
              {catagory.map((catagory_data, index) => (
                <div className="col-md-4" key={index}>
                  <div
                    className="evnsam-catagory"
                    onClick={() =>
                      navigate(`/eventslist`, {
                        state: { categorie_id: catagory_data._id },
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <figure>
                      <img
                        src={`${environment.imageBaseURL}categorie/${catagory_data.image}`}
                        alt=""
                      />
                    </figure>
                    <div className="evnsam-name">
                      <h4>{catagory_data.name}</h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </Layouts>
    </>
  );
}

export default Categorie;
